import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiImage, FiLoader } = FiIcons;

const ThumbnailCard = ({ thumbnail }) => {
  const [loading, setLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(thumbnail.url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `thumbnail_${thumbnail.quality}_${Date.now()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
      whileHover={{ y: -5 }}
    >
      <div className="relative aspect-video bg-gray-200 flex items-center justify-center">
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <SafeIcon icon={FiImage} className="text-gray-400 text-4xl" />
          </div>
        )}
        <img
          src={thumbnail.url}
          alt={`${thumbnail.quality} thumbnail`}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(false)}
        />
      </div>
      
      <div className="p-4">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-semibold text-gray-600 bg-gray-200 px-2 py-1 rounded">
            {thumbnail.quality}
          </span>
          <span className="text-xs text-gray-500">
            {thumbnail.dimensions}
          </span>
        </div>
        
        <motion.button
          onClick={handleDownload}
          disabled={loading}
          className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center space-x-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {loading ? (
            <>
              <SafeIcon icon={FiLoader} className="animate-spin" />
              <span>Downloading...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiDownload} />
              <span>Download</span>
            </>
          )}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ThumbnailCard;